import { Helmet } from 'react-helmet'

import { LpFaqs, LpFaq, LpLegalText, If } from '@itau-loans-www/components'
import { LandingPageLayout as Layout } from '@itau-loans-www/templates'
import { isOrganic } from '@itau-loans-www/utils'

const LandingPage = ({
  children,
  canonical,
  faqContent,
  partnerName,
  legalTextContent,
  product = 'fgts'
}) => {
  let structuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqContent.list.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer
      }
    }))
  }

  const isNewConsigFaqEnabled = product === 'consignado'

  return (
    <Layout partnerName={partnerName}>
      <Helmet>
        <link rel="canonical" href={canonical} />
        {/* TO DO: mover para o main layout a tag canonical */}
        {isOrganic && <meta name="robots" content="index, follow" />}
        <script type="application/ld+json">{`${JSON.stringify(
          structuredData
        )}`}</script>
      </Helmet>
      {children}
      <div
        className={`faq-section ${isNewConsigFaqEnabled ? '--consignado' : ''}`}
      >
        <If
          condition={isNewConsigFaqEnabled}
          renderIf={<LpFaq content={faqContent} />}
          renderElse={<LpFaqs content={faqContent} />}
        />
        <LpLegalText content={legalTextContent} />
      </div>
    </Layout>
  )
}

export default LandingPage
